import s from './Toggle.module.css';

export default function Toggle({ checked, onChange, label, disabled = false, ...rest }) {
  return (
    <label className={s.toggle}>
      <input
        type="checkbox"
        className={s.input}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        {...rest}
      />
      <span className={s.track}><span className={s.thumb} /></span>
      {label && <span className={s.label}>{label}</span>}
    </label>
  );
}
